import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../api/api";
import ProductCard from "../components/ProductCard";
import { useLanguage } from "../i18n/LanguageContext";

const HomePage = ({ onAddToOrder }) => {
  const [products, setProducts] = useState([]);
  const { t } = useLanguage();

  useEffect(() => {
    API.get("/api/products")
      .then((res) => setProducts(res.data.slice(0, 3)))
      .catch((err) => console.error("Error loading products", err));
  }, []);

  return (
    <div className="home-page">
      <div className="hero-section">
        <div className="hero-text">
          <span className="hero-eyebrow">{t("home.eyebrow")}</span>
          <h1>{t("home.headline")}</h1>
          <p>{t("home.subhead")}</p>
          <div className="hero-cta-row">
            <Link to="/products" className="btn">
              {t("home.cta")}
            </Link>
          </div>
        </div>
      </div>

      {products.length > 0 && (
        <div className="product-list">
          <h2 className="section-title">{t("home.featured")}</h2>
          <div className="product-grid">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToOrder={onAddToOrder}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
